import { IconX } from '@tabler/icons-react'
import type { MouseEvent } from 'react'

import { AstraIcon, AstraParagraph } from '~/astra'

type Props = {
    description: string
    onClick: () => void
    onDismiss: () => void
}

export const ReleaseNoteCard = ({ description, onClick, onDismiss }: Props) => {
    function handleDismiss(event: MouseEvent) {
        event.stopPropagation()
        onDismiss()
    }

    return (
        <div
            className="mx-1 flex cursor-pointer flex-col gap-2 rounded-xl border bg-surface-base p-3 shadow-md"
            onClick={onClick}
            data-test="release-note-card"
        >
            <div className="flex items-center justify-between gap-2">
                <AstraParagraph weight="medium" variant="body-small" onClick={onClick}>
                    Nytt i Hero
                </AstraParagraph>
                <button
                    type="button"
                    className="flex shrink-0 cursor-pointer items-center justify-center rounded p-0.5 hover:bg-surface-backdrop"
                    onClick={handleDismiss}
                    aria-label="Lukk"
                    data-test="release-note-card-dismiss"
                >
                    <AstraIcon icon={IconX} size="small" color="text-subtle" />
                </button>
            </div>
            <AstraParagraph onClick={onClick} variant="body-small">
                {description}
            </AstraParagraph>
        </div>
    )
}
